var map = {
	"./flag_en.png": 2943,
	"./flag_en_focus.png": 2944,
	"./flag_th.png": 2945,
	"./flag_th_focus.png": 2946
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4034;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login ^\.\/flag_.*\.png$
// module id = 4034
// module chunks = 1